import React, { useEffect, useState } from "react";
import { MATERIALCATALOG_API, ASSET_ACCESSORY_API } from "@app/utils/apiUrl";
import { Post, Get, Put } from "@app/utils/httpProvider";
import AccessoryEditModal from "./AccessoryEditModal";
import AccessoryAddModal from "./AccessoryAddModal";
import Table from "react-bootstrap/Table";


const AccessoryTab = ({ assetId }) => {
    const [accessories, setAccessories] = useState([]);
    const [editItem, setEditItem] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);

    const handleCloseModal = () => {
        setShowEditModal(false);
        setShowAddModal(false);
        setEditItem(null);
    }

    const handleSaveSuccess = () => {
        fetchAccessories();
        handleCloseModal();
    };

    const handleEdit = (item) => {
        setEditItem(item);
        setShowEditModal(true);
    };

    const handleAdd = () => {
        setEditItem(null);
        setShowAddModal(true);
    };


    useEffect(() => {
        if (assetId) {
            fetchAccessories();
        }
    }, [assetId]);

    const fetchAccessories = async () => {
        try {
            const accessoryData = await Get(`${ASSET_ACCESSORY_API.GET_BY_ASSET_ID}/${parseInt(assetId)}`);

            if (!accessoryData || accessoryData.length === 0) {
                setAccessories([]);
                return;
            }

            const materialIds = accessoryData.map(x => x.materialCatalogId);

            const materialRes = await Post(`${MATERIALCATALOG_API.GET_BY_LIST_ID}`, null, materialIds);

            const materials = await materialRes.json();

            const materialMap = {};
            materials.forEach(m => {
                materialMap[m.id] = m;
            });

            const mergedData = accessoryData.map(a => ({
                ...a,
                materialCode: materialMap[a.materialCatalogId]?.materialCode,
                materialName: materialMap[a.materialCatalogId]?.materialName,
                specification: materialMap[a.materialCatalogId]?.specification,
                unit: materialMap[a.materialCatalogId]?.unit,
                description: materialMap[a.materialCatalogId]?.description,
                note: a.note || ""
            }));

            setAccessories(mergedData);

        } catch (error) {
            console.error(error);
        }
    };

    const handleDelete = async (item) => {
        if (!window.confirm("Bạn có chắc muốn xóa phụ kiện này?")) return;

        try {
            if (!item) return;

            const payload = {
                assetId: item.assetId,
                materialId: item.materialCatalogId,
                quantity: Number(item.quantity),
                accessoryStatus: item.accessoryStatus,
                note: item.note || "",
                isDeleted: true
            };

            await Put(`${ASSET_ACCESSORY_API.UPDATE_ITEM}`, item.id, payload);
        
            fetchAccessories();

        } catch (error) {
            console.error(error);
            alert("Không thể cập nhật phụ kiện");
        }
    };

    const getAccessoryStatusStyle = (status) => {
        switch (status) {
            case 'Hoạt động': return { bg: 'rgba(40,167,69,0.12)', border: 'rgba(40,167,69,0.5)', text: '#28a745' };
            case 'Không hoạt động': return { bg: 'rgba(108,117,125,0.12)', border: 'rgba(108,117,125,0.5)', text: '#6c757d' };
            case 'Hỏng': return { bg: 'rgba(220,53,69,0.12)', border: 'rgba(220,53,69,0.5)', text: '#dc3545' };
            default: return { bg: 'rgba(108,117,125,0.1)', border: 'rgba(108,117,125,0.4)', text: '#6c757d' };
        }
    };

    return (
        <div className="">
            {/* <div className="card-body"> */}

            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0 text-primary">Danh sách phụ kiện</h6>

                <button type="button" className="btn btn-outline-success btn-sm" onClick={handleAdd}>
                    <i className="fas fa-plus mr-1" /> Thêm phụ kiện
                </button>
            </div>

            {/* Desktop View */}
            <div className="table-responsive d-none d-md-block">
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr className="text-dark fw-bold text-uppercase" style={{ fontSize: '12px', background: '#f8f9fa' }}>
                            <th className="text-center py-2" style={{ width: '50px' }}>STT</th>
                            <th className="py-2">Mã phụ kiện</th>
                            <th className="py-2">Tên phụ kiện</th>
                            <th className="py-2">Quy cách</th>
                            <th className="text-center py-2">Đơn vị</th>
                            <th className="text-center py-2">Số lượng</th>
                            <th className="text-center py-2">Trạng thái</th>
                            <th className="py-2">Ghi chú</th>
                            <th className="text-center py-2" style={{ width: '110px' }}>Thao tác</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accessories.length === 0 && (
                            <tr>
                                <td colSpan="9" className="text-center text-muted">
                                    Chưa có phụ kiện
                                </td>
                            </tr>
                        )}
                        {accessories.map((item, index) => (
                            <tr key={item.id}>
                                <td className="text-center">{index + 1}</td>
                                <td>{item.materialCode}</td>
                                <td>{item.materialName}</td>
                                <td>{item.specification}</td>
                                <td className="text-center">{item.unit}</td>
                                <td className="text-center">{item.quantity}</td>
                                <td className="text-center align-middle">
                                    {(() => {
                                        const s = getAccessoryStatusStyle(item.accessoryStatus);
                                        return (
                                            <span style={{
                                                display: 'inline-block',
                                                padding: '3px 10px',
                                                borderRadius: '999px',
                                                fontSize: '11px',
                                                fontWeight: 700,
                                                background: s.bg,
                                                color: s.text,
                                                border: `1px solid ${s.border}`,
                                                whiteSpace: 'nowrap',
                                            }}>
                                                {item.accessoryStatus}
                                            </span>
                                        );
                                    })()}
                                </td>
                                <td>{item.note}</td>
                                <td className="text-center">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm mr-1"
                                        onClick={() => handleEdit(item)}
                                        title="Sửa"
                                    >
                                        <i className="fas fa-pen" />
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() => handleDelete(item)}
                                        title="Xóa"
                                    >
                                        <i className="fas fa-trash" />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Mobile View */}
            <div className="d-block d-md-none">
                {accessories.length === 0 && (
                    <div className="text-center py-4 text-muted bg-light rounded border">
                        <i className="fas fa-box-open fa-2x mb-2 d-block text-secondary" />
                        Chưa có phụ kiện
                    </div>
                )}
                {accessories.map((item, index) => (
                    <div 
                        key={item.id} 
                        className="card mb-3 shadow-sm border rounded accessory-card"
                        style={{
                            borderLeft: '4px solid #007bff',
                            backgroundColor: '#ffffff'
                        }}
                    >
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <div>
                                    <span className="text-muted small fw-bold mr-2">#{index + 1}</span>
                                    <strong className="text-dark" style={{ fontSize: '15px' }}>{item.materialName}</strong>
                                    <div className="text-muted small mt-1">
                                        <i className="fas fa-barcode mr-1" /> Mã: {item.materialCode}
                                    </div>
                                </div>
                                {(() => {
                                    const s = getAccessoryStatusStyle(item.accessoryStatus);
                                    return (
                                        <span style={{
                                            display: 'inline-block',
                                            padding: '3px 10px',
                                            borderRadius: '999px',
                                            fontSize: '11px',
                                            fontWeight: 700,
                                            background: s.bg,
                                            color: s.text,
                                            border: `1px solid ${s.border}`,
                                            whiteSpace: 'nowrap',
                                        }}>
                                            {item.accessoryStatus}
                                        </span>
                                    );
                                })()}
                            </div>
                            <hr className="my-2" style={{ borderColor: '#f1f3f5' }} />
                            <div className="row g-2 text-muted small mb-2">
                                <div className="col-6">
                                    <strong>Quy cách:</strong> {item.specification || '-'}
                                </div>
                                <div className="col-6">
                                    <strong>Đơn vị:</strong> {item.unit || '-'}
                                </div>
                                <div className="col-6 mt-1">
                                    <strong>Số lượng:</strong> <span className="text-dark fw-bold">{item.quantity}</span>
                                </div>
                                {item.note && (
                                    <div className="col-12 mt-1">
                                        <strong>Ghi chú:</strong> <span className="font-italic">{item.note}</span>
                                    </div>
                                )}
                            </div>
                            <div className="d-flex justify-content-end gap-2 mt-2 pt-2 border-top" style={{ borderColor: '#f1f3f5' }}>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm mr-2"
                                    onClick={() => handleEdit(item)}
                                    style={{ borderRadius: '20px', padding: '4px 12px' }}
                                >
                                    <i className="fas fa-pen mr-1" /> Sửa
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={() => handleDelete(item)}
                                    style={{ borderRadius: '20px', padding: '4px 12px' }}
                                >
                                    <i className="fas fa-trash mr-1" /> Xóa
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {/* </div> */}
            <AccessoryEditModal
                show={showEditModal}
                // assetId={assetId}
                editItem={editItem}
                onClose={handleCloseModal}
                onSave={handleSaveSuccess}
            />
            <AccessoryAddModal
                show={showAddModal}
                assetId={assetId}
                onClose={handleCloseModal}
                onSave={handleSaveSuccess}
            />
        </div>
    );

};

export default AccessoryTab;